export var VERSION = '1.10.2';